module.exports = __webpack_public_path__ + "img/cost.f7564dfb.svg";